import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap } from 'lucide-react';
export function Hero() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 pb-12 px-4 overflow-hidden bg-white" data-id="element-68">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-69"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-70">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-wide mb-6 text-brand-text" data-id="element-71">
          CONVERTITE EN <span className="text-brand-green" data-id="element-72">EL 5</span> QUE EL
          EQUIPO NECESITA CUANDO EL PARTIDO SE DESORDENA
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-[380px] mx-auto mb-8 cursor-pointer group" onClick={scrollToCheckout} data-id="element-73">
          <div className="absolute inset-0 bg-brand-green/20 blur-3xl rounded-full group-hover:bg-brand-green/30 transition-colors duration-500" data-id="element-74"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pCc6Gk5ZBaPyh7Sa6gSJPE/ChatGPT_Image_May_20__2026__04_29_15_PM-removebg-preview.png" alt="Manual del 5 Moderno" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-75" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-brand-muted max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-76">
          Entrená lectura, ubicación y toma de decisiones para dejar de apagar
          incendios todo el partido.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col items-center gap-3" data-id="element-77">
          <button onClick={scrollToCheckout} className="bg-brand-green hover:bg-brand-greenHover text-white font-display text-3xl md:text-4xl py-4 px-10 rounded-lg uppercase tracking-wider transform transition-all hover:scale-105 hover:shadow-[0_10px_30px_rgba(22,163,74,0.35)] active:scale-95 w-full max-w-md shadow-lg shadow-brand-green/20" data-id="element-78">
            QUIERO DOMINAR LA CANCHA
          </button>
          <div className="flex items-center gap-4 text-sm text-brand-muted font-medium" data-id="element-79">
            <span className="flex items-center gap-1" data-id="element-80">
              <Shield className="w-4 h-4 text-brand-green" data-id="element-81" /> Pago seguro
            </span>
            <span data-id="element-82">•</span>
            <span className="flex items-center gap-1" data-id="element-83">
              <Zap className="w-4 h-4 text-brand-green" data-id="element-84" /> Acceso inmediato
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}